(() => {
  if (window.__socialProofInit) return;
  window.__socialProofInit = true;

  const AVATARS = [
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_2.png?v=1770220127",
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_3.png?v=1770220127",
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_4.png?v=1770220126",
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_5.png?v=1770220128",
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_1.png?v=1770220130",
    "https://cdn.shopify.com/s/files/1/0972/4818/2614/files/PERFIL_RSS_6.png?v=1770220127"
  ];

  const LOTS = [
    { name: "Anna",  count: "1,277" },
    { name: "Laura", count: "842" },
    { name: "María", count: "2,041" },
    { name: "Sofía", count: "611" },
    { name: "David", count: "1,109" },
    { name: "Paula", count: "936" },
    { name: "Carlos",count: "1,503" },
    { name: "Lucía", count: "728" }
  ];

  const PERIOD_MS = 5 * 60 * 1000;

  function hashString(str) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0);
  }

  function productKey() {
    return location.pathname || "product";
  }

  function pickLotIndex() {
    const slot = Math.floor(Date.now() / PERIOD_MS);
    return hashString(productKey() + "|" + slot) % LOTS.length;
  }

  function pickAvatarTriplet(seed) {
    const used = new Set();
    const picks = [];
    let s = seed >>> 0;

    while (picks.length < 3) {
      s = (s * 1664525 + 1013904223) >>> 0;
      const idx = s % AVATARS.length;
      if (AVATARS.length >= 3 && used.has(idx)) continue;
      used.add(idx);
      picks.push(AVATARS[idx]);
    }
    return picks;
  }

  function apply(el) {
    const lot = LOTS[pickLotIndex()];

    const nameEl = el.querySelector("[data-sp-name]");
    const countEl = el.querySelector("[data-sp-count]");
    if (nameEl) nameEl.textContent = lot.name;
    if (countEl) countEl.textContent = lot.count;

    const seed = hashString(productKey() + "|" + lot.name + "|" + lot.count);
    const [a1, a2, a3] = pickAvatarTriplet(seed);

    const img1 = el.querySelector("[data-sp-avatar-1]");
    const img2 = el.querySelector("[data-sp-avatar-2]");
    const img3 = el.querySelector("[data-sp-avatar-3]");

    if (img1) img1.src = a1;
    if (img2) img2.src = a2;
    if (img3) img3.src = a3;
  }

  function run() {
    document.querySelectorAll("[data-social-proof]").forEach(apply);
  }

  run();
  setInterval(run, 30 * 1000);
})();
